// src/services/authService.js
import api from './api'; // Import the Axios instance

// Login API
export const loginUser = async (credentials) => {
  const response = await api.post('users/login', credentials);
  return response.data;
};

// Register API
export const registerUser = async (userData) => {
  const response = await api.post('users/save', userData);
  return response.data;
};

// Forgot Password API
export const forgotPasswordApi = async (email) => {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
};

// Reset Password API
export const resetPasswordApi = async (data) => {
  const response = await api.post('/auth/reset-password', data);
  return response.data;
};


